<div class="alert alert-warning font-size-13 text-dark" *ngIf="length===0">
    <i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
    &nbsp; {{isRequestSuccess?message:'Lo sentimos, ha ocurrido un error en la búsqueda.'}} 
</div>
